// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 58" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M19.0027431,48.1066936 C16.5609916,50.5101007 12.6025208,50.5101007 
				10.1649361,48.1066936 C7.72318464,45.699178 7.72318464,41.7962092 
				10.1649361,39.3886936 C12.6025208,36.9852865 16.5609916,36.9852865 
				19.0027431,39.3886936 C21.4444946,41.7962092 21.4444946,45.699178 
				19.0027431,48.1066936 L19.0027431,48.1066936 Z M54.1039619,19.3027837 
				L60,13.4935224 L54.1039619,7.68426122 L48.2120907,1.875 L19.4444252,30.2393136 
				C14.3150804,28.4480563 8.37737421,29.5326708 4.26889823,33.5794334 
				C-1.42296608,39.1956004 -1.42296608,48.2997891 4.26889823,53.9159561 
				C9.96909615,59.5280146 19.1985833,59.5280146 24.8946144,53.9159561 
				C30.0864613,48.7969041 30.490642,40.8143054 26.2196604,35.1817049 
				L39.3742838,22.2074143 L45.8786763,28.6206086 L51.7705476,22.8113474 
				L45.2661551,16.3981531 L48.2120907,13.4935224 L54.1039619,19.3027837 
				Z" id="Fill-1"></path>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Lock.js